import { Hsluv as HsluvConvertor } from "hsluv";
const conv = new HsluvConvertor();
const convertHsluvToRgb = (color) => {
    conv.hsluv_h = color.h ?? 0;
    conv.hsluv_s = color.s * 100;
    conv.hsluv_l = color.l * 100;
    conv.hsluvToRgb();
    return { r: conv.rgb_r, g: conv.rgb_g, b: conv.rgb_b, alpha: color.alpha, mode: 'rgb' };
};
export default convertHsluvToRgb;
